import React, { FC }  from "react";
import { Form }       from "semantic-ui-react";
import ReservationUrl from "../../../../../domain/reservation/url/ReservationUrl";

interface Props {
  reservationUrl: ReservationUrl;
}

const ReservationUrlPreview: FC<Props> = (props: Props) => {
  const {reservationUrl} = props;
  return (
    <>
      <Form>
        <Form.Field>
          <label>HTMLプレビュー</label>
          <div dangerouslySetInnerHTML={ {__html: reservationUrl.toHtml()} }/>
        </Form.Field>
      </Form>
    </>
  );
};

export default ReservationUrlPreview;
